export const DateFormat = [
    {
      "formatName": "ISO 8601 with Slash",
      "format": "YYYY/MM/DD",
      "description": "International standard date format with slashes"
    },
    {
      "formatName": "US Date with Dashes",
      "format": "MM-DD-YYYY",
      "description": "U.S. date format with dashes"
    },
    {
      "formatName": "UK Date with Dashes",
      "format": "DD-MM-YYYY",
      "description": "UK date format with dashes"
    },
    {
      "formatName": "ISO 8601",
      "format": "YYYY-MM-DD",
      "description": "International standard date format"
    },
    {
      "formatName": "US Short Date",
      "format": "MM/DD/YYYY",
      "description": "Common U.S. date format"
    },
    {
      "formatName": "UK Short Date",
      "format": "DD/MM/YYYY",
      "description": "Common UK date format"
    },
    // {
    //   "formatName": "Long Date",
    //   "format": "MMMM D, YYYY",
    //   "description": "Full date with month name and year"
    // },
    {
      "formatName": "Month/Year",
      "format": "MM YYYY",
      "description": "Month name followed by year"
    },
    {
      "formatName": "Year/Month",
      "format": "YYYY/MM",
      "description": "Year followed by numeric month"
    },
    // {
    //   "formatName": "Day Month Year",
    //   "format": "D MMM YYYY",
    //   "description": "Day followed by short month name and year"
    // },
    {
      "formatName": "Year",
      "format": "YYYY",
      "description": "Only year"
    }
  ]
  